<template>
    <v-flex d-flex>
        <v-card :color="color" light>
            <v-card-title class="title">{{ title }}</v-card-title>
            <v-card-text>
                <v-container fluid grid-list-md>   
                    <v-layout row>
                        <v-flex :class="size" v-for="col in blockcomponents.columns">
                            <v-layout column v-if="col.length">                        
                                <keep-alive v-for="comp in col" :key="comp.id" >
                                    <component 
                                        :is="comp.name"
                                        :attributes="comp.attributes"
                                        :vuexnamespace="vuexnamespace"
                                    ></component>                                    
                                </keep-alive>    
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-flex>
</template>
<script>
    import forminput from "./FormInput.vue"
    import forminputfield from "./FormInputField.vue"
    import formmediaupload from "./FormMediaUpload.vue"
    import formselect from "./FormSelect.vue"
    import formdatatable from "./FormDataTable.vue"
    import formrecipesteptable from "./FormRecipestepTable.vue"
    import formprojectrecipestable from "./FormProjectrecipesTable.vue"
    import formsearchinput from "./FormSearchInput.vue"
    import formdatepicker from "./FormDatePicker.vue"
    export default { 
    name: "formblock",
    components: {
        forminput:forminput,
        formmediaupload:formmediaupload,
        formselect:formselect,
        formdatatable: formdatatable,
        formrecipesteptable:formrecipesteptable,
        formsearchinput:formsearchinput,
        formprojectrecipestable:formprojectrecipestable,
        forminputfield:forminputfield,
        formdatepicker:formdatepicker
        
    },
    props:[
       'title',
       'color',
       'columns',
       'vuexnamespace',
       'blockcomponents',
    ],
    data() {
        return {                   
            forminput:forminput,
            formmediaupload:formmediaupload,
            formselect:formselect,
            formdatatable: formdatatable,
            formrecipesteptable:formrecipesteptable,
            formsearchinput:formsearchinput,
            formprojectrecipestable:formprojectrecipestable,
            forminputfield:forminputfield,
            formdatepicker:formdatepicker
        }
    },
    computed: {
        size:()=>{return 'xs12'}
    },
    methods: {
        
        
    }
    
    
}
</script>